import React from "react";
import { searchLocations } from '@lds/store-locator-js-sdk';
import { useStoreCategories } from "./useStoreCategories";
export const useBullseyeLocations = ({ options, stateDispatcher, stateCategories }) => {
    const [stores, setStores] = React.useState(null);
    const [locationsError, setLocationsError] = React.useState(null);
    const [isLoading, setIsLoading] = React.useState(false);
    const catOptions = {
        lang: !options.lang ? 'en-CA' : options.lang,
        clientId: options.clientId,
        apiKey: options.apiKey,
    };
    const { getAllCategories, categories, isLoading: isCategoryLoading, error: categoryError, } = useStoreCategories(catOptions);
    const searchStores = React.useCallback(async () => {
        try {
            if ((typeof categories === 'undefined' || categories === null || isCategoryLoading) && (stateCategories || [])?.length === 0) {
                setStores(null);
                setLocationsError(null);
                setIsLoading(false);
                await getAllCategories();
                return;
            }
            // dont call any API during initial setup call
            if (options === null || typeof options.clientId === 'undefined' || !options.latitude || !options.longitude || isCategoryLoading) {
                setStores(null);
                setLocationsError(null);
                setIsLoading(false);
            }
            else {
                setIsLoading(true);
                if (categories?.length && stateDispatcher) {
                    stateDispatcher(categories);
                }
                const { storeList, error: err } = await searchLocations(options, categories || stateCategories);
                setStores(storeList);
                setLocationsError(err);
                setIsLoading(false);
            }
        }
        catch (errx) {
            setStores(null);
            setIsLoading(false);
            setLocationsError(errx);
        }
    }, [categories, isCategoryLoading, stateCategories, options, getAllCategories, stateDispatcher]);
    React.useEffect(() => {
        searchStores();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [JSON.stringify(options), categories]);
    const error = categoryError || locationsError;
    return { stores, error, isLoading };
};
//# sourceMappingURL=useBullseyeLocations.js.map